import { useMutation, UseMutationOptions } from 'react-query';
import { answerQuestionById } from '../data';
import { QuestionRequest, QuestionResponse } from '../types';

type QuestionMutationOptions = UseMutationOptions<QuestionResponse, Error, QuestionRequest>;

export const useQuestionMutation = (options?: QuestionMutationOptions) => {
  return useMutation(answerQuestionById, { ...options });
};
